import React from 'react';

// Vimeo's own player chrome provides fullscreen (Product's call), so there is no
// custom overlay button here — unlike the design prototype, which drew its own.
// Extraction guarantees every URL is a player.vimeo.com/video/<id> embed.
export default function VideoEmbed({ url }: { url: string }) {
  if (!url) return null;
  return (
    <div className="pc-lesson-video">
      <iframe
        src={url}
        title="Lesson video"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
